<div class="wrapper">
  <div class="tile">
    <h2 class="inter h2 w700">{{ 'app.contact.title' | i18n }}</h2>
    <div class="logo">
      <img alt="datafriends.cz" src="assets/img/datafriends.png" />
    </div>
<!--    <a class="inter large w700" href="tel:+420 733 528 797">-->
<!--      +420 733 528 797-->
<!--    </a>-->
    <a class="inter large w700"
       href="&#109;ai&#108;to&#58;s&#117;&#112;&#112;ort%40&#100;ata%66&#114;ien&#100;s&#46;cz">
      &#115;u&#112;&#112;ort&#64;datafrien&#100;s&#46;cz
    </a>
  </div>
</div>
